import {Outlet} from "react-router-dom";

const TaminAuth = () => {
  return <Outlet/>
}

export default TaminAuth;